export default "__VITE_ASSET__aJw47$kF__"